import { ReactNode } from 'react';
import cn from 'classnames';
import styles from './ContentPageSidebar.module.scss';

interface ContentPageSidebarProps {
  classNames?: string | string[];
  children: ReactNode;
}

const ContentPageSidebar = ({
  classNames,
  children,
}: ContentPageSidebarProps) => (
  <aside className={cn(styles.contentPageSidebar, classNames)}>
    {children}
  </aside>
);

export default ContentPageSidebar;
